import React from 'react';
import PropTypes from 'prop-types';

import './AllPostsIcon.scss';

const AllPostsIcon = ({ isActive }) => {
    const activeStyle = isActive ? 'active' : '';
    return (
        <svg
            className={`component-AllPostsIcon ${activeStyle}`}
            fill="none"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className="all-posts-outline"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.57986 17.5121L2.84569 10.1703C2.74127 9.12611 3.53247 8.25 4.58402 8.25H17.4158C18.4651 8.25 19.2587 9.12431 19.1541 10.1703L18.4199 17.5121C18.3228 18.483 17.4767 19.25 16.5039 19.25H5.49588C4.51945 19.25 3.67725 18.486 3.57986 17.5121ZM17.3196 10.0905L4.67985 10.0871L5.49989 17.4166H16.4999L17.3196 10.0905ZM6.41656 3.66667C6.41656 3.16041 6.82824 2.75 7.32901 2.75H14.6708C15.1747 2.75 15.5832 3.15688 15.5832 3.66667C15.5832 4.17293 15.1715 4.58333 14.6708 4.58333H7.32901C6.82508 4.58333 6.41656 4.17646 6.41656 3.66667ZM4.58323 6.41667C4.58323 5.91041 4.99568 5.5 5.49588 5.5H16.5039C17.008 5.5 17.4166 5.90688 17.4166 6.41667C17.4166 6.92293 17.0041 7.33333 16.5039 7.33333H5.49588C4.99184 7.33333 4.58323 6.92646 4.58323 6.41667Z"
            />
            <rect
                className="all-posts-fill"
                x="4"
                y="10"
                width="14"
                height="8"
            />
        </svg>
    );
};

AllPostsIcon.propTypes = {
    isActive: PropTypes.bool,
};

AllPostsIcon.defaultProps = {
    isActive: false,
};

AllPostsIcon.displayName = 'AllPostsIcon';

export default AllPostsIcon;
